module.exports = {"short_name":"KLO","name":"KLO","icons":[{"src":"favicon.ico","sizes":"64x64 32x32 24x24 16x16","type":"image/x-icon"}],"start_url":"./index.html","display":"standalone","theme_color":"#000000","background_color":"#ffffff"}


//////////////////
// WEBPACK FOOTER
// ./public/manifest.json
// module id = 540
// module chunks = 1